<template>
  <v-flex align="center" class="text-center">
    <IconToggle
      v-model="$store.state['unconfirmedBooking'].offerPublicly"
      text="BID"
    ></IconToggle>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          small
        >
          mdi-information
        </v-icon>
      </template>
      <span>
        Unconfirmed bookings are on BID by default. Toggle this to change that.
      </span>
    </v-tooltip>
  </v-flex>
</template>

<script>
import IconToggle from '@/components/widget/input/IconToggle'
export default {
  name: "UnconfirmedBookingOfferPubliclyCheckBox",
  components: {IconToggle}
}
</script>

<style scoped>

</style>